import { configureStore } from "@reduxjs/toolkit";
import hotelfilter from "./hotel-table-filer.js";
import bookingfilter from "./booking-table-filer.js";
import reportfilter from "./report-filer.js";

export const store = configureStore({ reducer: { hotelfilter, bookingfilter, reportfilter } });
